import { flatten } from 'lodash-es'
import { ImmutableVector3, getFlatShapeNormal } from '@modugen/ui-toolkit'

export const generateEdgesFromPoints = (points: ImmutableVector3[]): ImmutableVector3[][] => {
  return points.map((start, i) => {
    const end: Point = i + 1 === points.length ? points[0] : points[i + 1]

    return [start, end]
  })
}

export const generateShapeEdgesFromPoints = (
  points: ImmutableVector3[],
  thickness?: number,
  extrusionNormal?: ImmutableVector3,
): ImmutableVector3[][] => {
  const edges = generateEdgesFromPoints(points)
  if (!thickness || thickness === 0) return edges

  const normal =
    extrusionNormal ??
    getFlatShapeNormal(
      points as [ImmutableVector3, ImmutableVector3, ImmutableVector3, ...ImmutableVector3[]],
    )

  const thicknessEdges = points.map(p => [p, p.addScaledVector(normal, thickness)])
  const movedEdges = edges.map(edge => edge.map(p => p.addScaledVector(normal, thickness)))

  return [...edges, ...thicknessEdges, ...movedEdges]
}

export const generateOpeningEdges = (openings: Opening[]): ImmutableVector3[][] => {
  return flatten(
    openings.map(opening => {
      return generateEdgesFromPoints(opening.shape.points)
    }),
  )
}
